module.exports = __webpack_public_path__ + "static/media/ryan_karate.be302f4c.jpg";